import Vue from 'vue'
import Vuex from 'vuex'

import data from './data'
import display from './display'
import filter from './filter'
import search from './search'
import settings from './settings'
import settings_curation from './settings_curation'
import sort from './sort'
import values from './values'
import tabs from './tabs'

Vue.use(Vuex)

export default new Vuex.Store
    strict: true
    modules: {
        data
        display
        filter
        search
        settings
        settings_curation
        sort
        tabs
        values
    }
